import { SearchResponseDto } from '@wwt/entities/api/search-response'
import { OffersAndMetadata } from '@wwt/entities/search-response'

import { searchOffersAdapter } from './searchOffersAdapter.ts'

export const searchResponseAdapter = (
	searchResponse: SearchResponseDto
): OffersAndMetadata => {
	return {
		metadata: searchResponse.metadata,
		offers: searchOffersAdapter(searchResponse.content)
	}
}
